"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSound = exports.GameGalleryAccessState = exports.SUPERLIKE_SCORE_STRING = exports.SUPERLIKE_SCORE = exports.LIKE_SCORE_STRING = exports.LIKE_SCORE = exports.DISLIKE_SCORE_STRING = exports.DISLIKE_SCORE = exports.SNAPSHOT_FRAMES = exports.SNAPSHOT_FRAMES_PER_SECOND = exports.SNAPSHOT_HEIGHT = exports.SNAPSHOT_WIDTH = exports.WebcamStreamErrorCode = exports.WebcamStreamState = exports.GameSetupState = exports.GameStatus = exports.GameListGameStatus = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole[UserRole["User"] = 0] = "User";
    UserRole[UserRole["Host"] = 1] = "Host";
    UserRole[UserRole["Admin"] = 2] = "Admin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var GameListGameStatus;
(function (GameListGameStatus) {
    GameListGameStatus["Setup"] = "setup";
    GameListGameStatus["Active"] = "active";
    GameListGameStatus["Finished"] = "finished";
})(GameListGameStatus = exports.GameListGameStatus || (exports.GameListGameStatus = {}));
var GameStatus;
(function (GameStatus) {
    GameStatus["Setup"] = "setup";
    GameStatus["Pose"] = "pose";
    GameStatus["Score"] = "score";
    GameStatus["Results"] = "results";
    GameStatus["FinalResults"] = "finalResults";
    GameStatus["Finished"] = "finished";
})(GameStatus = exports.GameStatus || (exports.GameStatus = {}));
var GameSetupState;
(function (GameSetupState) {
    GameSetupState["Unsupported"] = "Unsupported";
    GameSetupState["LandingPage"] = "Landing Page";
    GameSetupState["PlayerName"] = "Player Name";
    GameSetupState["WebcamPermissions"] = "Webcam Permissions";
    GameSetupState["ProfilePicture"] = "Profile Picture";
    GameSetupState["Done"] = "done";
})(GameSetupState = exports.GameSetupState || (exports.GameSetupState = {}));
var WebcamStreamState;
(function (WebcamStreamState) {
    WebcamStreamState[WebcamStreamState["Inactive"] = 0] = "Inactive";
    WebcamStreamState[WebcamStreamState["Active"] = 1] = "Active";
    WebcamStreamState[WebcamStreamState["Error"] = 2] = "Error";
})(WebcamStreamState = exports.WebcamStreamState || (exports.WebcamStreamState = {}));
var WebcamStreamErrorCode;
(function (WebcamStreamErrorCode) {
    WebcamStreamErrorCode[WebcamStreamErrorCode["Permission"] = 0] = "Permission";
    WebcamStreamErrorCode[WebcamStreamErrorCode["InUse"] = 1] = "InUse";
    WebcamStreamErrorCode[WebcamStreamErrorCode["NoCamera"] = 2] = "NoCamera";
    WebcamStreamErrorCode[WebcamStreamErrorCode["Unknown"] = 3] = "Unknown";
})(WebcamStreamErrorCode = exports.WebcamStreamErrorCode || (exports.WebcamStreamErrorCode = {}));
exports.SNAPSHOT_WIDTH = 480;
exports.SNAPSHOT_HEIGHT = 480;
exports.SNAPSHOT_FRAMES_PER_SECOND = 4;
exports.SNAPSHOT_FRAMES = 3;
exports.DISLIKE_SCORE = 0;
exports.DISLIKE_SCORE_STRING = exports.DISLIKE_SCORE.toLocaleString();
exports.LIKE_SCORE = 1000;
exports.LIKE_SCORE_STRING = exports.LIKE_SCORE.toLocaleString();
exports.SUPERLIKE_SCORE = 2500;
exports.SUPERLIKE_SCORE_STRING = exports.SUPERLIKE_SCORE.toLocaleString();
var GameGalleryAccessState;
(function (GameGalleryAccessState) {
    GameGalleryAccessState[GameGalleryAccessState["Loading"] = 0] = "Loading";
    GameGalleryAccessState[GameGalleryAccessState["PinRequired"] = 1] = "PinRequired";
    GameGalleryAccessState[GameGalleryAccessState["Granted"] = 2] = "Granted";
})(GameGalleryAccessState = exports.GameGalleryAccessState || (exports.GameGalleryAccessState = {}));
var GameSound;
(function (GameSound) {
    GameSound[GameSound["Countdown"] = 0] = "Countdown";
    GameSound[GameSound["Swipe"] = 1] = "Swipe";
    GameSound[GameSound["RoundWinner"] = 2] = "RoundWinner";
    GameSound[GameSound["DrumRoll"] = 3] = "DrumRoll";
    GameSound[GameSound["FinalResults"] = 4] = "FinalResults";
})(GameSound = exports.GameSound || (exports.GameSound = {}));
//# sourceMappingURL=Other.js.map